module.exports = __webpack_public_path__ + "static/media/QualitativeIcon.f8a0736c.svg";